export const OCV_APP_ID = 2746;
export const FEEDBACK_HOST_NAME = 'Iamexperiences';
export const FEEDBACK_SCOPES = ['https://world.ocv.microsoft.com/.default'];
export const FEEDBACK_CONTAINER_ID = 'inAppFeedbackRef';

/**
 * Maps to OCV feature areas for filtering feedback submissions.
 * Each value corresponds to a specific area within MyApps.
 */
export enum FeedbackFeature {
  MyApps = 'MyApps'
}

